import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { useHistory } from "react-router";
import React, { useEffect, useState } from "react";
import { getMonthIcon, getMonth, monthList } from "../../helpers/Common_functions";
import { BottomNavigation, BottomNavigationAction, FormControl, Typography } from "@mui/material";
import { getError } from "../../store/helpers/common_functions";
import PageLoading from "../../helpers/PageLoading";
import moment from "moment";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { InfoOutlined } from "@mui/icons-material";
import PartnerWorklogContent from "./PartnerWorklogContent";

const PartnerWorklogReport = ({ FetchDetails, loggedUser, GetLoggedUser, resources, partner }) => {
    const [error, setError] = useState(null);
    const [months, setMonths] = useState([]);
    const [activeTab, setActiveTab] = useState(
        parseInt(moment(new Date()).format('M')) - 1
    );
    const [activeMonth, setActiveMonth] = useState(
        parseInt(moment(new Date()).format('M'))
    );
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [active, setActive] = useState(1);
    const currentYear = new Date().getFullYear();
    const yr = [];
    for (let i = currentYear; i >= currentYear - 10; i--) {
        yr.push({ year: i, count: 0 });
    }
    const [years, setYears] = useState(yr);
    const [activeYear, setActiveYear] = useState(currentYear);
    const [dates, setDates] = useState([]);

    useEffect(() => {
        GetLoggedUser();
    }, [GetLoggedUser]);

        useEffect(() => {
            loadMonths().then();
        }, []);


    const getNumDays = () => {
        return moment(`${activeYear}-${months[activeTab]?.month}`, "YYYY-M").daysInMonth();
    }

    useEffect(() => {
        if (months.length - 1 >= activeTab) {
            const num = getNumDays();
            let arr = [];
            for (let i = 1; i <= num; i++) {
                arr.push({ label: i });
            }
            setDates(arr);
            setActiveMonth(months[activeTab]?.month);
        }
    }, [activeTab, months, active]);


    const loadMonths = async () => {
        // const resp = await FetchDetails(`/api/worklogs/report/user/${partner?.user?.id}${activeYear ? `?year=${activeYear}` : ''}`);
        // if (resp.status) {
        //     const years = resp.data.years;
            const months = monthList?.map((month) => {
                const isMonthExist = false;

                return { month: month.value, year: isMonthExist ? isMonthExist?.year : activeYear, count: isMonthExist ? isMonthExist?.count : 0 }
            })

            setMonths(months);

            // setYears(years);
            // if (years.filter(v => v.year === activeYear).length <= 0 && years.length) {
            //     setActiveYear(years[0].year);
            // }
        // }
    }

    const history = useHistory();


    const isMe = active === loggedUser?.resourceId;
    const loadProfileData = async () => {
        setLoading(true);
        setError(null);
        const resp = await FetchDetails(isMe ? `/api/profile/details` : `/api/resource/details/${active}`);
        setLoading(false);
        if (resp.status) {
            setInfo(resp.data);
        } else {
            setError(getError(resp));
        }
        return resp;
    }

    useEffect(() => {
        loadMonths().then();
    }, [activeYear, active]);



    return (loading) || error ? <PageLoading error={loading ? null : error}  /> : <div className={'h-full'}>
        <div className={'flex h-full flex-col'}>
            <div className={'flex items-center w-full bg-white  p-2 shadow border-bottom'}>
                <div className={'flex-grow'}>
                    <BottomNavigation
                        showLabels
                        value={activeTab}
                        onChange={(event, newValue) => {
                            setActiveTab(newValue);
                        }}
                    >
                        {months.map((el, index) => <BottomNavigationAction value={index} label={getMonth(el.month)} icon={getMonthIcon(el.month)} />)}
                    </BottomNavigation>
                </div>
                <div style={{ width: "100px" }}>
                    <FormControl size={'small'} variant={'standard'} fullWidth>
                        {/*<InputLabel id="demo-simple-select-label">Select Year</InputLabel>*/}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={activeYear}
                            placeholder="Select Year"
                            onChange={(e) => {
                                setActiveYear(e.target.value);
                            }}
                        >
                            {years.map(v =>
                                <MenuItem value={v.year}>{v.year}</MenuItem>)}
                        </Select>
                    </FormControl>
                </div>
                {/* <div className="ml-3">
                    <QtMaterialButton onClick={() => {
                    
                    }} variant={'contained'} className={'bg-qt'}>Download</QtMaterialButton>
                </div> */}
            </div>
            <div className={'flex-grow'}>
                {!months.length ? <div className={'h-full flex items-center justify-center'}>
                    <div className={'text-center'}>
                        <div><InfoOutlined style={{ fontSize: "40px" }} /></div>
                        <div>
                            <Typography>No Report data found !</Typography>
                        </div>
                    </div>
                </div> : <PartnerWorklogContent partner={partner} dates={dates} year={activeYear} month={activeMonth}/>}
            </div>
        </div>
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerWorklogReport);